export default function Content({children}) {
  return children;
}

Content.type = Symbol('MiniVariantDrawer.Content');
